import { Injectable } from "@angular/core";
import { GridLayoutService } from "@irb-common/interfaces/grid-layout.service";
import { ImportSecurityModelsContainsDialogComponent } from "@irb/irb-models/import-security-model-contains-dialog/import-security-model-contains-dialog.component";

@Injectable({
  providedIn: "root",
})
export class ImportSecurityModelsContainsGridLayoutService implements GridLayoutService<ImportSecurityModelsContainsDialogComponent> {
  constructor() {}

  getFrameworkComponents() {
    return {};
  }

  getColumnDefs() {
    return [
      {
        headerName: "Symb/Csp",
        field: "securitySymbol",
        maxWidth: 100
      },
      {
        headerName: "Description",
        field: "securityDescription",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        }
      },
      {
        headerName: "Type",
        field: "securityType",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        maxWidth: 125
      },
      {
        headerName: "CustCat",
        field: "customCategoryName",
        cellRenderer: "cellRendererFormatter",
        cellRendererParams: {
          text: (params: any) => {
            return params.value != null && params.value.length > 0;
          },
        },
        maxWidth: 170
      },
    ];
  }
}
